import { Controller, useFormContext } from 'react-hook-form';

import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

// ----------------------------------------------------------------------
// Free-form list of strings entered as chips (type a value and press Enter, or
// paste comma/space separated values). The bound form value is a string[].
// The text-equivalent of RHFNumberChips.
// ----------------------------------------------------------------------

const SEPARATORS = /[\n,;\t]+/;

export function RHFTextChips({ name, label, helperText, placeholder }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const value = Array.isArray(field.value) ? field.value : [];
        return (
          <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={value}
            onChange={(_, newValue) => {
              // Split any pasted/typed entries that contain separators, trim, dedupe.
              const flat = newValue
                .flatMap((item) => String(item).split(SEPARATORS))
                .map((s) => s.trim())
                .filter(Boolean);
              field.onChange(Array.from(new Set(flat)));
            }}
            renderTags={(tags, getTagProps) =>
              tags.map((option, index) => (
                <Chip
                  size="small"
                  variant="soft"
                  label={option}
                  {...getTagProps({ index })}
                  key={option}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                placeholder={value.length === 0 ? placeholder ?? 'Type and press Enter' : ''}
                error={!!error}
                helperText={error ? error?.message : helperText}
                slotProps={{
                  htmlInput: { ...params.inputProps, autoComplete: 'off' }
                }}
              />
            )}
          />
        );
      }}
    />
  );
}
